import React from 'react';
import { Control, FieldErrors, UseFormSetValue, UseFormTrigger } from 'react-hook-form';
import { TitleFull } from '@warehouse/title/core';
import DisplayTitleField from '../fields/DisplayTitle';
import WorkTypeDetailField from '../fields/WorkTypeDetail';
import { ParentTitleCard } from '../fields/ParentTitleCard';

interface CompilationProps {
	workType: string;
	control: Control<any>;
	setValue: UseFormSetValue<any>;
	trigger: UseFormTrigger<any>;
	errors: FieldErrors<any>;
	selectedParentTitle?: TitleFull;
}

function Compilation({ workType, control, errors, setValue, trigger, selectedParentTitle }: CompilationProps) {
	return (
		<div>
			<WorkTypeDetailField
				workType={workType}
				control={control}
				setValue={setValue}
				trigger={trigger}
				errors={errors}
				isRequired
			/>
			<DisplayTitleField control={control} setValue={setValue} errors={errors} trigger={trigger} isRequired />
			<ParentTitleCard selectedParentTitle={selectedParentTitle} />
		</div>
	);
}

export default Compilation;
